<template>
  <div class="container-fluid ib-auth-bg">
    <loading class="register-overlay" v-show="showLoader"/>

    <div class="row">
      <div class="col-md-4 offset-md-4 px-5">
        <div class="jbl-otp-h-right jbl-otp-right">

          <div class="text-center d-block my-5">
            <router-link :to="{ name: 'Home' }">
              <img alt="Logo Icon" class="img-fluid in-fluid-70" :src="require('@/assets/images/ib-logo.svg')" />
            </router-link>
          </div>

          <h5 class="ib-auth-desc" style="">Lost your Password<span class="Qmark">?</span><br>Make a new password easily </h5>
          <form @submit.prevent="ResetPassword" id="resetEmail">
            <div>
              <div class="ib-input-field">
                <label class="jbl-label-sign">Email</label>
                <input class="ib-login-input" type="text" id="exampleInputEmail1" placeholder="Email" name="email" required/>
              </div>
            </div>
            <div class="text-center">
              <button type="submit" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'

  export default {
    name: 'ForgotPassword',
    components: {
      loading
    },
    data () {
      return {
        showLoader : false,
      }
    },
    methods: {
      ResetPassword () {
        const self = this;
        self.showLoader = true;
        var formData = new FormData(document.getElementById('resetEmail'));

        axios.post('customer/password/reset', formData).then(function (response) {
          if (response.data.code == 201) {
            self.$router.push({ name: 'Home' });
            $toast.success(response.data.message, { position: 'top-right' });
          } else {
            $toast.error('Email not found', { position: 'top-right' });
          }
          self.showLoader = false;

        }).catch(function (error) {
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .jbl-field.jbl-otp-field {
    margin-left: 1.2rem;
  }

  @media (max-width:850px) and (min-width: 750px) {
    .jbl-field.jbl-otp-field {
      margin-left: .5rem;
    }
  }

  @media (max-width:450px) {
    .jbl-otp-field {
      min-width: 300px !important;
    }

    /* .jbl-otp-right h5 {
      font-family: "Futura PT Medium";
      font-size: 25px;
      font-weight: 500;
      line-height: 1.28;
      color: #5b6770;
    } */
  }

  @media (min-width:451px) {
    .jbl-otp-field {
      min-width: 380px !important;
    }
  }

  .jbl-otp-right h5 span {
    /* color: #ba0c2f; */
    font-size: inherit !important;
    color: inherit !important;
  }
  @media(max-width:550px){
  .jbl-otp-right h5{
    font-size: 15px !important;
    font-family: "Futura PT Medium";
    font-weight: 500;
    line-height: 1.28;
    color: #5b6770;
  }
  .in-fluid-70{
    max-width: 70% !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Auth/ForgotPassword.vue